export class carousel_data{
  constructor(
    public id:number,
    public img:string,
    public content:string,
    public count:string
  ) {
  }
}
